// react
import { Map, fromJS } from "immutable";

export const initialState = fromJS({
	ajaxQueries: Map(),
});

export default function uiState(state = initialState, action) {
	switch (action.type) {
		case "USERS:GET@SUCCESS":
		case "USERS:SEARCH@SUCCESS": {
			const users = action.response;
			const query = action.request.props.q;

			return state.setIn(["ajaxQueries", query], users);
		}

		default:
			return state;
	}
}
